import template from './qrCodeScan.html';

class QrCodeScanController {
    constructor($q) {
        this.$q = () => $q;
    }

    $onInit() {
        this.scanner = new Instascan.Scanner({ video: document.getElementById('preview')});
        this.scanner.addListener('scan', (content) => {
            this.onData({content: content});
        });
        Instascan.Camera.getCameras().then((cameras) => {
            this.cameras = cameras;
            if (cameras.length > 0) {
                this.activeCameraId = cameras[0].id;
                this.scanner.start(cameras[0]);
            } else {
                console.error('No cameras found.');
            }
        }).catch(function (e) {
            console.error(e);
        });
    }

    selectCamera(camera) {
        const $q = this.$q();
        this.scanner.stop().then(() => {
            $q.when(this.scanner.start(camera)).then(() => {
                this.activeCameraId = camera.id;
            });
        })
    }

    formatName (camera) {
      return camera.name || '(unknown)';
    }

    $onDestroy() {
        this.scanner.stop().then(() => {
            console.log('Scan stoped');
        });

    }

}

QrCodeScanController.$inject = ['$q'];

const QrCodeScanComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: QrCodeScanController,
    controllerAs: 'vm',
    bindings:{
        onData: '&'
    }
};

export {QrCodeScanComponent};
export {QrCodeScanController};



// WEBPACK FOOTER //
// ./app/components/common/qrCodeScanner/qrCodeScan.component.js